// @ts-check

import React from "react";
import { useNavigate } from "react-router-dom";
import { Link, Text, Tooltip } from "@shopify/polaris";

export const TruncatedTableUTMValue = ({
  value,
  nullValue = "-",
  calculateReportHref,
  truncateLength = 30,
}) => {
  const navigate = useNavigate();

  if (!value) {
    return nullValue;
  }

  let metricValue = value;
  const shouldTruncateValue = value.length > truncateLength;
  
  if (shouldTruncateValue) {
    metricValue = (
      <Text as="span">
        {metricValue.substring(0, truncateLength).trim()}...
      </Text>
    );
  }

  if (calculateReportHref) {
    const handleClick = () => {
      const href = calculateReportHref(value);
      navigate(href);
    }

    metricValue = (
      <Link
        onClick={handleClick}
        removeUnderline
      >
        {metricValue}
      </Link>
    )
  }

  if (shouldTruncateValue) {
    metricValue = (
      <Tooltip content={value} dismissOnMouseOut>
        {metricValue}
      </Tooltip>
    );
  }

  return metricValue;
};
